// extracted by mini-css-extract-plugin
module.exports = {"Main":"style-module--Main--3mJfV","hide":"style-module--hide--JwO34"};